import { createAction, handleActions } from "redux-actions";
import uuidv4 from "uuid/v4";
//
import { LOCATION_STORE } from "./locations";
import { MODAL_SCREEN_SHOW } from "./modal/actionTypes";

const initialState = uuidv4();

export default handleActions(
  {
    [LOCATION_STORE.FULFILLED]: () => uuidv4(),
    [MODAL_SCREEN_SHOW]: (state, action) =>
      action.payload === "location" ? uuidv4() : state,
  },
  initialState
);
